<template>
  <el-dialog title="分区信息"
             width="800px"
             :visible.sync="visibleValue"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :modal-append-to-body="true"
             :append-to-body="true"
             :lock-scroll="false"
             @closed="closedCallback">
    <el-form inline>
      <el-form-item>
        <el-input v-model="searchText" placeholder="请输入邮编"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      max-height="400px"
      size="mini"
      border>
      <el-table-column label="分区名称" width="160px" prop="partitionSchemeName"/>
<!--        <template slot-scope="scope">-->
<!--          分区1-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="邮编">
        <template slot-scope="scope">
          <zip-code-list
            :list="scope.row.zipCodes"
            />
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import ZipCodeList from "@/components/placeOrder/components/zipCodeRegionSearch/zipCodeList";

export default {
  name: "zipCodeRegionSearch",
  components: {ZipCodeList},
  mixins:[mixinsDialog],
  props:{
    list: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      // 筛选状态
      loadingSearch:false,
      // 筛选文本
      searchText:"",
      // 表格显示内容
      tableData:[],
    }
  },
  watch:{
    isShow(val){
      // console.log("watch isShow",val);
      if(val){
        this.searchList();
      }else {
        this.reset();
      }
    },
    list(val){
      // console.log("watch isShow");
      if(this.isShow) this.searchList()
    }
  },
  methods:{
    reset(){
      this.loadingSearch = false;
      this.searchText = "";
      this.tableData = [];
    },
    searchList(text = this.searchText){
      text = `${text}`.replace(/(^\s+)|(\s+$)/g,"");
      console.log("搜索邮编",text);
      let arr = [];
      if(text){
        // console.log("this.list.length(1) = ",this.list.length)
        this.list.forEach(one=>{
          let zipCodes = one.zipCodes||[];
          zipCodes = zipCodes.filter(zipCode=>{
            let reg = RegExp(text,"ig");
            return reg.test(zipCode);
          })
          if(zipCodes.length){
            let item = Object.assign({},one,{
              zipCodes:zipCodes,
            })
            arr.push(item)
          }
        });
      }else{
        // console.log("this.list.length(2) = ",this.list.length)
        arr = this.list
      }
      this.tableData = arr;
    },
  },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/zipCodeRegionSearch/index.vue